import React from 'react'
import { Handle, Position } from '@xyflow/react';

const initStyle = {
    width: 10,
    height: 10,
    borderRadius: '50%',
    background: '#4CAF50',
    border: '2px solid #fff',
    boxShadow: '0 0 0 1px #4CAF50',
    transition: 'all 0.2s ease',
}

function SourceHandle({ id, styles }) {
    return <Handle id={id} type="source" position={Position.Right} style={{...initStyle, ...styles}} />
}

export default SourceHandle
